import React,{ useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Button,Col,Form,Row} 
from "react-bootstrap";
import DataTable from "react-data-table-component";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDownload,faSearch,faTrash} from "@fortawesome/free-solid-svg-icons";
import "assets/css/grid.css";
import { useFichaConsultante } from 'hooks/useFichaConsultante';
import {MensajeAlerta} from '../Messages/MensajeAlerta';
const paginacionOpciones={
    rowsPerPageText:'Número elementos',
    rangeSeparatorText:'de',
    selectAllRowsItemsText:'Todos'
}
function ListadoArchivosFicha(){
  
    const columnas=[
    {
        name:'Id',
        selector: row => row.Id,
        sorteable:true,
        omit:true
    },
    {
        name:'Nombre',
        selector: row => row.Nombre,
        sorteable:true
    },
    {
        name:'Descripcion',
        selector: row => row.Descripcion,
        sorteable:true
    },
    {
        name:'FechaIngreso',
        selector:row => row.FechaIngreso,
        sorteable:true,
        right:true
    },
    {
        name: 'Acciones',
        button: true,
		cell: row => (
            <>
           
            <a href='#' onClick={(e)=>downloadFile(row.Id)}  
            >
            	<FontAwesomeIcon icon={faDownload} />
               
            </a>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <a href='#' onClick={(e)=>deleteFile(row.Id)} >
            <FontAwesomeIcon icon={faTrash} />
            </a>
            </>       
        ),
    }
    ];
    const parametros = useParams();
    const [selectedFile, setSelectedFile] = useState();
    const [descripcion, setDescripcion] = useState('');
	//const [isFilePicked, setIsFilePicked] = useState(false);
    const [isChangedElements,setChange]=useState(false);
    const { archivosFicha,getArchivosFicha,loadArchivoFicha,getArchivoFicha,
        respuestaSubidaArchivo,updateRespuestaSubir,deleteArchivoFicha } = useFichaConsultante({Id:parametros.id});
    
    const onChange=async e=>{
        e.persist();
        if(e.target.value.length>3){
            //getUsuariosConsultantes(e.target.value);
        }
    }
    const onChangeHandlerFile = (event) => {
		setSelectedFile(event.target.files[0]);
	};
	const handleSubmission = async() => {
        if(selectedFile){
            setChange(false);
            const resp=await loadArchivoFicha(selectedFile,descripcion);
            if(resp.success)
            {
                setChange(true);
                setDescripcion('');
            }
        }
	};
    const downloadFile=async(ArchivoId)=>{
        const resp=await getArchivoFicha(ArchivoId);
        if(resp.Data!=null){
        const filex=new Buffer.from(resp.Data.data).toString("base64")
        const url = "data:image/png;base64," + filex;
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', resp.Nombre);
        document.body.appendChild(link);
        link.click();

        }
    }
    const deleteFile=async(ArchivoId)=>{
        setChange(false);
        const resp=await deleteArchivoFicha(ArchivoId);
        if(resp.success==1){
            setChange(true);
        }
    }
    const handleChange = event => {
        let valor=event.target.value;
        setDescripcion(valor);
      };

    /*useEffect( async() => {
        await getArchivosFicha();
        await updateRespuestaSubir();    
    }, [isChangedElements]);*/

    useEffect( () => {
        async function setListadoArchivos(){
            await getArchivosFicha();
            await updateRespuestaSubir();    
        }
        setListadoArchivos();
    }, [isChangedElements]);

        return (
            <>
                <>
                    <Row  style={{marginLeft: "15px"}}>
                    <Col xs="6">
                    <div className='form-group files'>
                    <label>Subir nuevo documento</label><br></br>
                    <input type="file" className='form-control' name="ArchivoPorSubir" onChange={onChangeHandlerFile} /><br></br>
                    <Button
                        className="btn-fill pull-right"
                        type="submit"
                        variant="info"
                        onClick={(e)=>{
                            e.preventDefault();
                            handleSubmission();
                        }}
                      >
                    Subir Archivo
                    </Button>
                    <br></br>
                    <MensajeAlerta mensajeTexto={respuestaSubidaArchivo.mensajeTexto} estado={respuestaSubidaArchivo.estado} />
                  
                    </div>
                    </Col>
                    <Col xs="6">
                        <label>Descripción</label>
                        <Form.Control
                        id='ArchivoDescripcion'
                        defaultValue={descripcion}
                        placeholder=""
                        type="text"
                        onChange={handleChange}
                        ></Form.Control>
                    </Col>
                    </Row>
          
                </>
          
                <Row>
                <Col>
                <div className='table-responsive'>
                <div className='barraBusqueda'>
                    <input
                        type="text"
                        placeholder="Buscar"
                        className="textField"
                        name="busqueda"
                        onChange={onChange}
                        
                    />
                    <button type='button' className='btnBuscar'>
                        <FontAwesomeIcon icon={faSearch} />
                    </button>
                </div>

            <DataTable
                columns={columnas}
                data={archivosFicha}
                pagination
                paginationComponentOptions={paginacionOpciones}
                fixedHeader
                fixedHeaderScrollHeight='600px'
                noDataComponent="No hay elementos para mostrar"
                striped={true}
                
            />
            </div>

                </Col>
                </Row>
           
           
            </>
        )
}
export default ListadoArchivosFicha;